<script>

    export let lines; 
    export let lineColours;

    console.log("LINE COLOURS", lineColours)

</script>

<div class='badges-con'>

    {#each lines as line}
        <div 
            class='badge' 
            style={`background-color: #${lineColours[line].colour}`}    
        >{lineColours[line].name}</div>
    {/each}

</div>

<style>
    .badges-con {
        flex-wrap: wrap;
        display: flex;
    }

    .badge {
        font-size: 11px;
        padding: 2px 5px;
        font-weight: 700;
        border-radius: 5px;
        margin-right: 5px;
        margin-top: 5px;
        color: white;
    }

    .white {
        color: white;
    }

</style>